import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from '../App.tsx';
import './index.css';

// Register PWA Service Worker dynamically from /sw.js
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  const registerWithRetry = () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        console.log('PWA Service Worker registered successfully with scope:', reg.scope);
      })
      .catch(err => {
        console.error('PWA Service Worker registration failed:', err);
      });
  };

  if (document.readyState === 'complete') {
    registerWithRetry();
  } else {
    window.addEventListener('load', registerWithRetry);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
